import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent, ref, watchEffect } from "vue"; // modules

import POSConfigModule from "@/store/modules/pos-config";
import { PCTypes } from "@/types/db/product-category";
import { getProductCategoriesWithPricesArray, getProductCategoriesWithFlatPrice } from "@/utils/helpers/product-category";
import { getAllTimeSlotsByProductCategory, getFutureTimeSlotsByProductCategory } from "@/utils/helpers/timeslots";
import { recordOperationDuration } from "@/utils/vue-helpers/common";
import { useIntersectionObserver } from "@vueuse/core";
import { LogService } from "@/services/logging";
import { onMounted } from "vue";
import { PRODUCT_CATEGORY_PAGINATION_LIMIT } from "@/constants/app";
export default defineComponent({
  name: "TicketsGrid",
  props: {
    ticketGroupId: {
      type: Number,
      required: true
    }
  },
  components: {},
  setup: function setup(props) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var loading, selectedConfig, productCards, keys, groupedProducts, didScroll, productsCount, noMoreProducts, loadTrigger, isLoadingProducts, sortProductCategories, _sortProductCategories, handleScroll, handleTouchStart, loadProducts, _loadProducts, resetState;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              resetState = function _resetState() {
                productsCount.value = 0;
                noMoreProducts.value = false;
                isLoadingProducts.value = false;
                productCards.value = [];
                keys.value = [];
                groupedProducts.value = {};
              };

              _loadProducts = function _loadProducts3() {
                _loadProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  var newCards, newProductsCount, isSeparatedButtons, _yield$getProductCate, cards, pcCount;

                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          isLoadingProducts.value = true;
                          _context2.prev = 1;
                          newCards = null;
                          newProductsCount = 0;
                          isSeparatedButtons = POSConfigModule.isSeperatedButtons;

                          if (isSeparatedButtons) {
                            _context2.next = 12;
                            break;
                          }

                          _context2.next = 8;
                          return getProductCategoriesWithPricesArray(props.ticketGroupId, productsCount.value);

                        case 8:
                          newCards = _context2.sent;
                          newProductsCount = newCards.length;
                          _context2.next = 19;
                          break;

                        case 12:
                          _context2.next = 14;
                          return getProductCategoriesWithFlatPrice(props.ticketGroupId, productsCount.value);

                        case 14:
                          _yield$getProductCate = _context2.sent;
                          cards = _yield$getProductCate.cards;
                          pcCount = _yield$getProductCate.pcCount;
                          newCards = cards;
                          newProductsCount = pcCount;

                        case 19:
                          if (newProductsCount) {
                            _context2.next = 22;
                            break;
                          }

                          // no new products were fetched
                          noMoreProducts.value = true;
                          return _context2.abrupt("return");

                        case 22:
                          productsCount.value += newProductsCount;
                          productCards.value = [].concat(_toConsumableArray(productCards.value || []), _toConsumableArray(newCards || [])); // Seating plan logic:
                          // from productCards exclude any recurring seating plan since it shouldn't be shown in a alphabetic grid, it should be shown in a calendar

                          productCards.value = productCards.value.filter(function (pc) {
                            return !pc.isReccuringSeating;
                          });
                          _context2.next = 27;
                          return sortProductCategories();

                        case 27:
                          // update cards list and the count index
                          if (!newProductsCount || newProductsCount < PRODUCT_CATEGORY_PAGINATION_LIMIT) {
                            // No more products in db
                            // Let's update noMoreProducts to hide the loader element
                            noMoreProducts.value = true;
                          }

                          _context2.next = 33;
                          break;

                        case 30:
                          _context2.prev = 30;
                          _context2.t0 = _context2["catch"](1);
                          LogService.info("Error when fetching products from indexedDB", _context2.t0);

                        case 33:
                          _context2.prev = 33;
                          isLoadingProducts.value = false;
                          return _context2.finish(33);

                        case 36:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[1, 30, 33, 36]]);
                }));
                return _loadProducts.apply(this, arguments);
              };

              loadProducts = function _loadProducts2() {
                return _loadProducts.apply(this, arguments);
              };

              handleTouchStart = function _handleTouchStart(e) {
                didScroll.value = false;
              };

              handleScroll = function _handleScroll(e) {
                didScroll.value = true;
              };

              _sortProductCategories = function _sortProductCategorie2() {
                _sortProductCategories = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var now, i, timeslots, _i, letter;

                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (productCards.value) {
                            _context.next = 2;
                            break;
                          }

                          return _context.abrupt("return");

                        case 2:
                          // 2- Add timeslots data to the product Availability/StartDateTime/EndDateTime OR get retail-option data if it is a retail product
                          now = new Date().toISOString(); // console.log("now");
                          // console.log(now);
                          // console.log("lastMonth");
                          // console.log(lastMonth.toISOString());

                          i = 0;

                        case 4:
                          if (!(i < productCards.value.length)) {
                            _context.next = 19;
                            break;
                          }

                          if (!(productCards.value[i].type === PCTypes[PCTypes.Seated])) {
                            _context.next = 11;
                            break;
                          }

                          _context.next = 8;
                          return getAllTimeSlotsByProductCategory(Number(productCards.value[i].productCategoryId), 1);

                        case 8:
                          _context.t0 = _context.sent;
                          _context.next = 14;
                          break;

                        case 11:
                          _context.next = 13;
                          return getFutureTimeSlotsByProductCategory(Number(productCards.value[i].productCategoryId), now, 1);

                        case 13:
                          _context.t0 = _context.sent;

                        case 14:
                          timeslots = _context.t0;

                          if (timeslots && timeslots.length) {
                            // In case of a none-reccuring seating plan we are taking dbAvailability from childrenPSC.resource.quantity, and it seems this field actually has the total quantity
                            // we need to substract what was already booked from it which we can get from timeslots[0].booked
                            // TODO Hamza: One Concept to Discuss with the Team:
                            // a. None Reccuring Seating Quantity resides in childPSC.resource.quantity
                            // b. Already booked seats number resides in timeslots[0].booked
                            // c. Now we are deducting what was already booked from total quantity, but the user is still able to go to seats io and make seats available for sales, in this case POS will not know this, how we should handle this case? And did we actually have users who went to seats io and made sold seats available again?
                            if (productCards.value[i].type === PCTypes[PCTypes.Seated] && !productCards.value[i].isReccuringSeating) {
                              if (!productCards.value[i].dbAvailability) {
                                productCards.value[i].dbAvailability = 0;
                              } else {
                                productCards.value[i].dbAvailability = Number(productCards.value[i].dbAvailability) - timeslots[0].booked;
                              }
                            } else {
                              productCards.value[i].dbAvailability = timeslots[0].availability;
                            }

                            productCards.value[i].startDateTime = timeslots[0].startDateTime;
                            productCards.value[i].endDateTime = timeslots[0].endDateTime;
                            productCards.value[i].timeslot_ID = timeslots[0]._id; // TODO Hamza: Reccuring Seating Plan logic
                            // Check if pc.type = 3 and pc.isParentReccuringSeating = 1 then we assign productCards.value[i].eventKey = timeslots[0].eventKey

                            if (productCards.value[i].type === PCTypes[PCTypes.Seated] && productCards.value[i].isReccuringSeating) {
                              // Since the card is holding a reccuring seating plan sub-category then we will ignore eventKey value coming from parentCategory
                              // and consider the eventKey that resides inside Timeslot entity
                              productCards.value[i].eventKey = timeslots[0].eventKey;
                            }
                          }

                        case 16:
                          i++;
                          _context.next = 4;
                          break;

                        case 19:
                          // 3- Group productCategories by alphabet
                          for (_i = 0; _i < productCards.value.length; _i++) {
                            letter = String(productCards.value[_i].categoryName)[0].toUpperCase(); // lets check if this record has product categories of this letter

                            if (!groupedProducts.value || groupedProducts.value[letter]) {
                              // so this letter has a record already, lets add the currect product category to this record
                              groupedProducts.value[letter].push(productCards.value[_i]);
                            } else {
                              // so the record does not have product categries of this letter, lets add it
                              groupedProducts.value[letter] = [productCards.value[_i]];
                            }
                          }

                          keys.value = Object.keys(groupedProducts.value); // console.log("returning");
                          // console.log(groupedProducts.value);

                          return _context.abrupt("return", groupedProducts.value);

                        case 22:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return _sortProductCategories.apply(this, arguments);
              };

              sortProductCategories = function _sortProductCategorie() {
                return _sortProductCategories.apply(this, arguments);
              };

              loading = ref(false);
              selectedConfig = ref(POSConfigModule.selectedConfig); // Get product categories from local db

              productCards = ref([]); //  keys are the alphabets the user sees grouping the ProductCategories

              keys = ref(); // initiating a the variable with an empty object, cast it to be Record type, and make it reactive

              groupedProducts = ref({});
              didScroll = ref(false); // used for pagination when fetching PCs from indexedDB

              productsCount = ref(0);
              noMoreProducts = ref(false);
              loadTrigger = ref();
              isLoadingProducts = ref(false);
              /**
               * Sort product categories alphabetically, then group them by alphabet
               */

              watchEffect(function () {
                if (props.ticketGroupId) {
                  resetState();
                }
              });
              onMounted(function () {
                useIntersectionObserver(loadTrigger, function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 1),
                      isIntersecting = _ref2[0].isIntersecting;

                  if (isIntersecting) {
                    var operationStartTime = performance.now();
                    loadProducts();
                    var operationEndTime = performance.now();
                    var operationDuration = operationEndTime - operationStartTime;
                    recordOperationDuration("TicketsGrid_refresh", operationDuration);
                  }
                });
              });
              return _context3.abrupt("return", {
                selectedConfig: selectedConfig,
                loading: loading,
                productCards: productCards,
                keys: keys,
                groupedProducts: groupedProducts,
                sortProductCategories: sortProductCategories,
                // sumArray,
                getProductCategoriesWithPricesArray: getProductCategoriesWithPricesArray,
                getProductCategoriesWithFlatPrice: getProductCategoriesWithFlatPrice,
                didScroll: didScroll,
                handleScroll: handleScroll,
                handleTouchStart: handleTouchStart,
                loadProducts: loadProducts,
                loadTrigger: loadTrigger,
                isLoadingProducts: isLoadingProducts,
                noMoreProducts: noMoreProducts
              });

            case 20:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});